<template>
<!--<Layout>-->
<!--<PageHeader :title="title" :items="items" />-->
    <b-overlay spinner-type="grow" style="height: 100vh;" rounded="true" variant="dark" show spinner-variant="light"></b-overlay>
<!--</Layout>-->
</template>
<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import {clientAdminState} from '@/state/helpers.js'
import store from '@/state/store'
import Swal from 'sweetalert2'
import router from "@/router";

/**
 * Dashboard Component
 */
export default {
    page: {
        title: "Dashboard",
        meta: [
            {
                name: "description",
                content: appConfig.description,
            },
        ],
    },
    computed:{
        ...clientAdminState,
    },
    /*watch:{
        'core_data'(){
            //redirect user to client or admin default view once loaded
            //this.setViewType();
        }
    },*/
    components: {
        /* eslint-disable-next-line */
        Layout,PageHeader,
    },
    methods:{
        setViewType(){
        if(this.core_data != null){
            if(this.core_data.ccb_admin === true){
                //* CCB ADMIN default route
                //todo Get last route from local storage if available
                router.replace('/admin/applicants');
            }
            else if(this.core_data.client_admin === true){
                if(this.core_data.pre_application){
                    router.replace('/clientadmin/timeline');
                }
                else{
                    //TODO - Add normal route here
                    router.replace('/documents');
                }
            }
            else{
                if(this.core_data.pre_application){
                    Swal.fire({
                        toast: true, position: 'top', iconColor: 'white', icon: 'info', title:'Pre Application Required',
                        customClass: {popup: 'info-toast' }, showConfirmButton: false, timer: 4000, timerProgressBar: true
                    });
                    router.replace('/client/timeline');
                }
                else{
                    Swal.fire({
                        toast: true, position: 'top', title:'Welcome Back',
                        customClass: {popup: 'success-toast' }, showConfirmButton: false, timer: 3000, timerProgressBar: true
                    });
                    router.replace('/documents');
                }
            }
        }
        /*else{
            setTimeout(()=>{
                this.setViewType();
            }, 250)
        }*/
        }
    },
    data() {
        return {
            title: "Dashboard",
            items: [
                {
                    text: "Dashboards",
                    href: "/",
                },
                {
                    text: "Default",
                    active: true,
                },
            ],
        };
    },
    mounted() {
        store.dispatch('auth/refresh').then((validUser) => {
            if(validUser){
                if(this.core_data != null){
                    this.setViewType();
                }
            }
            else{
                router.push('/logout');
            }
        })
    },
};
</script>

<style>
span.spinner-grow{
    width: 4rem;
    height: 4rem;
}
</style>


